import Vue from 'vue';
import App from './App.vue';
import './registerServiceWorker';
import router from './router';
import store from './store';
import 'vue-cool-lightbox/dist/vue-cool-lightbox.min.css';
import CoolLightBox from 'vue-cool-lightbox';
import lego from './plugins/lego';
import axios from 'secure-axios';
import 'lego-framework/src/scss/variables/lego-variables.scss';
import './assets/style.scss';

import 'font-icons/nunito/nunito.css';
import 'font-icons/simple-line-icons/css/simple-line-icons.css';
import 'font-icons/iconsmind-s/css/iconsminds.css';
import 'font-icons/nucleo/css/nucleo.css';
import VueNumber from 'vue-number-animation';
import Box from 'lego-framework/src/containers/Box';
import AOS from 'aos';
import 'aos/dist/aos.css';
import VueSocialSharing from 'vue-social-sharing';
import VueScrollTo from 'vue-scrollto';

Vue.use(VueSocialSharing);

Vue.config.productionTip = false;

Vue.use(lego);
Vue.use(VueNumber);
Vue.use(VueScrollTo);
Vue.use(CoolLightBox);
Vue.component('Box', Box);
// AOS.init({ delay: 2500 });
new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app');

document.onreadystatechange = function () {
    if (document.readyState === 'complete') {
        AOS.init();
    }
};
axios.interceptors.response.use(async (response) => {
    if (response?.status === 400 && response.data.error === true && response.data.message) {
        Vue.prototype.$notify(response.data.message, 'Error',
            {
                type: 'danger'
            }
        );
        console.warn(response.data.message); // warning for 400/any error response
    } else if (response?.status !== 200 && response?.status !== 400) {
        Vue.prototype.$notify('Something went wrong..!', 'Error', {
            type: 'danger',
            duration: 3000,
            permanent: false
        });
    }

    if (response.data.permission === false) {
        const permissionDeniedChannel = new BroadcastChannel('permission-denied');
        permissionDeniedChannel.postMessage({ type: 'denied' });
    }
    return response;
}, error => {
    const data = error?.response?.data || {};
    const status = error?.response?.status;

    if (status === 400 && data.error === true && data.message) {
        Vue.prototype.$notify(data.message, 'Error',
            {
                type: 'danger'
            }
        );
        console.warn(data.message);
    } else if (status !== 200 && status !== 400 && status !== 500) {
        Vue.prototype.$notify('Something went wrong..!', 'Error', {
            type: 'danger',
            duration: 3000,
            permanent: false
        });
    }
    console.error('axios-error-response:', error);
    return Promise.reject(error);
});
